var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.proxyWaveCircles),function(item){return _c('l-circle',{key:item.key,ref:"proxyCircles",refInFor:true,attrs:{"weight":3,"lat-lng":item.center,"radius":item.radius,"color":item.color,"fill-opacity":0}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }